import React from "react";
import { Toolbar } from "primereact/toolbar";

const FrameSuperior = () => {
  const startContent = <React.Fragment></React.Fragment>;
  const centerContent = <div>YIWU YAMIN TRADING</div>;
  const endContent = <div>V7.0.0</div>;

  return (
    <div className="card">
      <Toolbar start={startContent} center={centerContent} end={endContent} />
      {/* Renderizamos el modal 
            {isModalOpen && (
                <CrearPedidoModal
                    isOpen={isModalOpen}
                    onClose={() => setIsModalOpen(false)} // Cerramos el modal
                />
            )}
                */}
    </div>
  );
};

export default FrameSuperior;
